import { Engine1Proxy } from 'com-gyf-webcore-servicehub';

let IngresoAjusteManager = function () {

    const dataSourceAjuste = 'EVENTSOURCING_TRANSACTION_AJUSTE';
    const dataSourceAjusteVisa = 'EVENTSOURCING_TRANSACTION_AJUSTE_VISA';

    /**
     * 
     * @param {any} cobranza
     * @param {any} viewCallback
     */
    function _guardarAjuste(cobranza, viewCallback) {
        let isQuery = false;
        let deleteInstance = false;
        const localValues = mapearAjuste(cobranza);
        Engine1Proxy.AddEventSourcingDataRequest(localValues, dataSourceAjuste, 'Tarjetas', feature, null, isQuery, null, deleteInstance, id);
        Engine1Proxy.Execute((data) => _guardarAjusteVisa(data, viewCallback), null, null, feature);
    }

    /**
     * 
     * @param {any} data
     * @param {any} viewCallback
     */
    function _guardarAjusteVisa(data, viewCallback) {
        let isQuery = false;
        let deleteInstance = false;
        const localValues = {
            "AJUSTE_ID": data.EVENTSOURCING_TRANSACTION_AJUSTE
        };
        Engine1Proxy.AddEventSourcingDataRequest(localValues, dataSourceAjusteVisa, 'Tarjetas', feature, null, isQuery, null, deleteInstance, id);
        Engine1Proxy.Execute(viewCallback, null, null, feature);
    }

    /**
     * 
     * @param {any} ajuste
     * @param {any} viewCallback
     */
    function _actualizarAjuste(ajuste, viewCallback) {
        let isQuery = false;
        let deleteInstance = false;
        const localValues = mapearAjuste(ajuste);
        Engine1Proxy.AddEventSourcingDataRequest(localValues, dataSourceAjuste, 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, ajuste.Id);
        Engine1Proxy.Execute(viewCallback, null, null, "ADMINEMPCUETAR");
    }

    /**
     * 
     * @param {any} ajuste
     * @param {any} viewCallback
     */
    function _eliminarAjuste(ajuste, viewCallback) {
        let isQuery = false;
        let deleteInstance = false;
        const localValues = mapearAjuste(ajuste);
        Engine1Proxy.AddEventSourcingDataRequest(localValues, dataSourceAjuste, 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, ajuste.Id);
        Engine1Proxy.Execute(viewCallback, null, null, "ADMINEMPCUETAR");
    }

    /**
     * 
     * @param {any} ajuste
     */
    function mapearAjuste(ajuste) {
        let values = {
            "ID": ajuste.Id,
            "ENTIDAD_BANCO_EMISOR_ID": ajuste.EntidadBancoEmisorId,
            "SUCURSAL_ID": ajuste.SucursalId,
            "CUENTA_TARJETA_ID": ajuste.CuentaTarjetaId,
            "CUENTA_TARJETA_SALDO_ID": ajuste.CuentaTarjetaSaldoId,
            "FECHA_CREACION": ajuste.FechaCreacion,
            "FECHA_AJUSTE": ajuste.FechaAjuste,
            "FECHA_PRESENTACION": ajuste.FechaPresentacion,
            "FECHA_CIERRE": ajuste.FechaCierre,
            "FECHA_PROCESADOR_ADINTAR": ajuste.FechaProcesadoAdintar,
            "FECHA_PROCESADOR_ADMINISTRADORA": ajuste.FechaProcesoAdministradora,
            "FECHA_CAMBIO_ESTADO": ajuste.FechaCambioEstado,
            "AJUSTE_ESTADO_ID": ajuste.AjusteEstadoId,
            "AJUSTE_MONEDA_ID": ajuste.AjusteMonedaId,
            "IMPORTE": ajuste.Importe,
            "FSAC": ajuste.FSAC,
            "AJUSTE_ORIGEN_ID": ajuste.AjusteOrigenId,
            "AJUSTE_MODO_INGRESO": ajuste.AjusteModoIngreso,
            "INFORMAR_ADMINISTRADORA": ajuste.InformarAdministradora,
            "CARGADO_POR_ADMINISTRADORA": ajuste.CargadoPorAdministradora,
            "AJUSTE_CARTERA_ID": ajuste.AjusteCarteraId,
            "DEBITO_CREDITO": ajuste.DebitoCredito,
            "FECHA_INFORMA_EMERIX": ajuste.FechaInformaEmerix,
            "IMPORTE_SIN_IVA": ajuste.ImporteSinIva                
        };
        return values;
    }

    return {
        GuardarAjuste: function (ajuste, viewCallback) {
            return _guardarAjuste(ajuste, viewCallback);
        },
        ActualizarAjuste: function (ajuste, viewCallback) {
            return _actualizarAjuste(ajuste, viewCallback);
        },
        EliminarCobranza: function (ajuste, viewCallback) {
            return _eliminarAjuste(ajuste, viewCallback);
        }
    }
};

let ingresoAjusteManager = new IngresoAjusteManager();

module.exports = ingresoAjusteManager;


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Common/Managers/IngresoAjusteManager.js